<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled || readonly()" placeholder="Status auswählen">
  @if (showAll()) {
    <nb-option [value]="null">Alle</nb-option>
  }
  @for (status of enumValues(); track status) {
    <nb-option [value]="status">{{ status | repairTaskStatusTranslation }}</nb-option>
  }
</nb-select>
